import styled, { css } from "styled-components";

import type { TableCell } from "app/pages/workspace/sales/components/custom-table/types";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledTableColumn = styled.div<Omit<TableCell, "text"> & { length: number }>`
    & > div {
        ${({ align }) => {
            const justifyContent = align === "right" ? "flex-end" : align === "center" ? "center" : "flex-start";
            const textAlign = align ? align : "left";

            return css`
                justify-content: ${justifyContent};
                text-align: ${textAlign};
            `;
        }};
    }

    ${({ length, size }) => {
        if (length === 1 || typeof size === "undefined") {
            return css`
                flex-grow: 1;
            `;
        }

        return css`
            flex: 0 0 ${size};
        `;
    }};
`;

export const StyledWrapperTableBody = styled.div``;

export const StyledTableBody = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const StyledTableHeader = styled.div<{ isSticky: boolean }>`
    display: flex;
    justify-content: flex-end;
    ${({ isSticky }) =>
        isSticky &&
        css`
            position: sticky;
            top: 0;
            z-index: 1;
        `};
`;

export const StyledTable = styled(FlexColumn)`
    height: 100%;
    width: 100%;
`;
